import { FileUploadInfo } from '@price-for-profit/micro-services';
import { useSnackbar } from 'notistack';
import { useQueryClient, useMutation } from 'react-query';
import { useService } from 'shared/providers';

export function useUploadPdfFiles() {
  const { enqueueSnackbar } = useSnackbar();
  const { pdfUploadService } = useService();
  const queryClient = useQueryClient();
  const mutation = useMutation<FileUploadInfo[], Error, FormData>(request => pdfUploadService.uploadPdfFile(request), {
    onSuccess: () => {
      enqueueSnackbar('File uploaded', { variant: 'success' });
      queryClient.invalidateQueries('files');
    },
    onError: error => {
      enqueueSnackbar('Could not upload file', { variant: 'error' });
      console.log('File not uploaded ', error);
    },
  });

  return mutation;
}
